import React from 'react';
import NoDataFound from 'Common/NoDataFound';
import useSuperSearchDropdownContext from 'NewComponents/FormComponents/SuperSearchDropdown/useSuperSearchDropdownContext';

const CptSuperSearchTemplate = ({ handleSelectedData, identifier, height = '100%', width = '100%' }) => {
  const { state, onSetSelectedRowNumber, onSetSearchStatus, onSetInputValue, onToggleDropDown } = useSuperSearchDropdownContext();
  const { data, selectedRowNumber } = state;

  const handleSingleRow = (row, index) => {
    onSetSelectedRowNumber(index);
    handleSelectedData(row);
    onSetSearchStatus(false);
    onSetInputValue('');
    onToggleDropDown(false);
  };

  return (
    <div
      style={{ height: data.length > 0 ? 'auto' : height, width, minHeight: '10px', maxHeight: '300px', overflow: 'auto' }}
      className='mt-1 rounded-md border bg-white p-2 shadow-xl shadow-gray-200/50'
    >
      {data.length > 0 ? (
        <div className='space-y-1'>
          {data.map((item, index) => {
            const isSelected = index === selectedRowNumber;
            return (
              <div
                key={`${item.cptCode}-${index}`}
                id={`${identifier}_${index}`}
                onClick={() => handleSingleRow(item, index)}
                className={`cursor-pointer rounded-md px-2.5 py-1.5 text-xs hover:bg-[#F3F4F7] transition-colors ${isSelected
                  ? 'bg-[#F3F4F7] '
                  : ''
                  }`}
              >
                <div className='font-semibold'>{item.cptCode}</div>
                <div className='truncate opacity-90'>{item.description}</div>
              </div>
            );
          })}
        </div>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default CptSuperSearchTemplate;
